import BaseService from '../../base/base_service';
import Store from '../../utils/store';
import _ from '../../utils/underscore';
import {SystemEventSubscription} from '../../utils/event';
import {IObservableSubscription} from '../../utils/observable';
import {SYSTEM_EVENTS} from '../../events/events';
import { ServiceDependencies } from '../../base/base_service_interface';
import Device from "../../utils/device/device";


const CURRENT_RUNNING_GAME_TAB = 'CURRENT_RUNNING_GAME_TAB';
const CURRENT_RUNNING_GAME_TYPE = 'CURRENT_RUNNING_GAME_TYPE'

export default class MaxOneOpenGameService extends BaseService {
    static CLASS = 'MaxOneOpenGameService';

    private _fromIntervalSubscription: IObservableSubscription;

    injectDependencies(dependencies: ServiceDependencies): void {
        super.injectDependencies(dependencies);
        this._startCheckingGameRunningInAnotherTab();
        this._subscribe();
    }

    private _startCheckingGameRunningInAnotherTab() {
        if(this.serviceFactory.regulationService().shouldPreventMoreThanOneOpenGame()) {
            this._fromIntervalSubscription = this.serviceFactory.observableFactoryService().fromInterval(1000).forEach(() => {
                if(this.isGameRunningInAnotherTab()) {
                    this.serviceFactory.gameService().closeRunningGame();
                }
            });
        }
    }

    private _onOauthChangeSubscription: SystemEventSubscription;
    private _onGameOpenSubscription: SystemEventSubscription;
    private _onCloseGameSubscription: SystemEventSubscription;
    private _onCloseAllOverlaySubscription: SystemEventSubscription;
    private _onBrowserPageHideSubscription: SystemEventSubscription;

    private _subscribe(): void {
        if(this.serviceFactory.regulationService().shouldPreventMoreThanOneOpenGame()) {
            this._onOauthChangeSubscription = this.onSystemEvent(SYSTEM_EVENTS.OAUTH_STATE_CHANGE, this._onOauthChange.bind(this));
            this._onGameOpenSubscription = this.onSystemEvent(SYSTEM_EVENTS.GAME_OPEN, this._onGameOpen.bind(this));
            this._onCloseGameSubscription = this.onSystemEvent(SYSTEM_EVENTS.CLOSE_GAME, this._onCloseGame.bind(this));
            this._onCloseAllOverlaySubscription = this.onSystemEvent(SYSTEM_EVENTS.CLOSE_ALL_OVERLAY, this._onCloseAllOverlay.bind(this));
            this._onBrowserPageHideSubscription = this.onSystemEvent(SYSTEM_EVENTS.ON_BROWSER_PAGE_HIDE, this._onBrowserTabUnload.bind(this));
        }
    }

    private _onOauthChange() {
        if(!this.serviceFactory.oAuth2Service().isAuthorized) {
            this._clearStorage();
        }
    }

    private _onGameOpen(gameInfo): void {
        Store.set(CURRENT_RUNNING_GAME_TAB, this.serviceFactory.windowService().getCurrentBrowserTabId());
        Store.set(CURRENT_RUNNING_GAME_TYPE, gameInfo.gameType);
    }

    private _clearStorage(): void {
        Store.del(CURRENT_RUNNING_GAME_TAB);
        Store.del(CURRENT_RUNNING_GAME_TYPE);
    }

    private _onCloseGame(gameInfo): void {
        if(this._isGameRunningInTheCurrentTab() && this.getCurrentRunningGameType() === gameInfo.gameType) {
            this._clearStorage();
        }
    }

    private _onCloseAllOverlay(): void {
        if(this._isGameRunningInTheCurrentTab()) {
            this._clearStorage();
        }
    }

    private _onBrowserTabUnload(): void {
        if(this._isGameRunningInTheCurrentTab()) {
            this._clearStorage();
        }
    }

    isGameRunningInAnotherTab(): boolean {
        if (this.serviceFactory.integrationService().isMiniOrbit()) {
            return false;
        }

        if (Device.hybrid.isHybrid) {
            return false;
        }

        let runningTabId = this._getRunningGameTabId();
        if (_.isEmpty(runningTabId)) {
            return false;
        }

        if (runningTabId !== this.serviceFactory.windowService().getCurrentBrowserTabId()) {
            return true;
        }
        return false;
    }

    private _isGameRunningInTheCurrentTab() {
        return !this.isGameRunningInAnotherTab();
    }

    private _getRunningGameTabId(): string {
        return Store.get(CURRENT_RUNNING_GAME_TAB);
    }

    getCurrentRunningGameType(): number {

        let gameType = parseInt(Store.get(CURRENT_RUNNING_GAME_TYPE));
        if(_.isNumber(gameType)) {
            return gameType;
        } else {
            return null;
        }
    }

    dispose() {
        if(this._fromIntervalSubscription) {
            this._fromIntervalSubscription.dispose();
        }
        if(this._onGameOpenSubscription) {
            this._onGameOpenSubscription.off();
        }

        if(this._onOauthChangeSubscription) {
            this._onOauthChangeSubscription.off();
        }

        if(this._onCloseGameSubscription) {
            this._onCloseGameSubscription.off();
        }



        if(this._onBrowserPageHideSubscription) {
            this._onBrowserPageHideSubscription.off();
        }

        if(this._onCloseAllOverlaySubscription) {
            this._onCloseAllOverlaySubscription.off();
        }
    }
}